import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchHighlightsByUser({ userId }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `downtimereasonhighlight/${userId}`,
    });
    yield put(Actions.setHighlightsByUser({ highlightsByUser: data }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* bulkUpdateHighlights({ params }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.post, {
      route: 'downtimereasonhighlight/BulkUpdate',
      data: params,
    });
    // Optionally refetch highlights after update
    yield put(Actions.fetchHighlightsByUser(params.userId));
    yield put(Actions.setLoader({ showLoader: false }));
    notification('success', CONSTANT_VARIABLES.DOWNTIME_REASON_HIGHLIGHTS_UPDATED, '');
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err);
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_HIGHLIGHTS_BY_USER, fetchHighlightsByUser),
    takeLatest(ActionTypes.BULK_UPDATE_HIGHLIGHTS, bulkUpdateHighlights),
  ]);
}
